import React, { useState, Fragment } from 'react';
import * as Yup from 'yup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';

import numeral from 'numeral';
import moment from 'moment';

import Alerts from '../../utils/alerts';
import agm from '../../services/agm';
import Confirmations from '../../utils/confirmations';
import FindExpense from '../expenses/Find';
import FindProductLpu from '../productslpu/Find'
import CreateProductLpu from '../productslpu/Create'
import CreateProductExpense from '../products/Create'
import { AiOutlineClear } from "react-icons/ai";
import BuildIcon from '@material-ui/icons/Build';

import Taskbar from './Taskbar';

import Documents from './Documents';
import ResultsExpenses from './ResultsExpenses';
import ResultsProducts from './ResultsProducts';
import ResultsInfra from './ResultsInfra';
import ResultsEquipment from './ResultsEquipment';
import ResultsSchedule from './ResultsSchedule';
import ResultsActions from './ResultsActions';
import ResultsOrdemCompra from './ResultsOrdemCompra';
import ResultsPlanejamento from './ResultsPlanejamento';
import ItemOrcamento from './Item';

import PaymentIcon from '@material-ui/icons/Payment';
import { MdSave } from 'react-icons/md';
import { MdOutlineFileUpload } from 'react-icons/md';
import { MdFileDownload } from 'react-icons/md';
import { ImFilePdf } from "react-icons/im";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { BsHddNetworkFill } from "react-icons/bs";
import { BsFillCalendarDateFill } from "react-icons/bs";
import { FaMoneyBillWave } from "react-icons/fa";
import { FaTasks } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import NumberFormat from 'react-number-format';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Button,
    TextField,
    Card,
    CardHeader,
    CardContent,
    Checkbox,
    IconButton,
    FormControlLabel,
    TableContainer,
    Table,
    TableRow,
    TableCell,
    TableBody,
    Link,
    Dialog,
    DialogTitle,
    DialogContent
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.cyan[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    doned: {
        padding: 5
    },
    container: {
        minHeight: 600
    },
    infrascontainer: {
        minHeight: 50,
        maxHeight: 50
    },
    grouplabel: {
        color: colors.blue[300]
    },
    groupdivider: {
        borderTop: `1px solid ${colors.blue[300]}`
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

function TabPanel(props) {
    const { children, value, index, selectedMode, ...other } = props;

    return (
        <div
            margin="0px"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box
                    marginTop={2}
                    marginBottom={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 2 : 0}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const expensesColumns = [
    { name: 'Código', field: 'item.codigo', size: 50, sortable: 0, exportable: 0 },
    { name: 'Nome', field: 'item.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Tipo', field: 'item.tipo.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Qtd', field: 'formatDecimal(item.qtd)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Valor Despesa', field: 'formatDecimal(item.valor)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total Despesa', field: 'formatDecimal(((item.valor * item.qtd)))', size: -1, sortable: 0, exportable: 0 },
    { name: 'Nota', field: 'item.nota', size: -1, sortable: 0, exportable: 0 },
    { name: 'Fornecedor', field: '(item.fornecedor) ? item.fornecedor.nome: ""', size: -1, sortable: 0, exportable: 0 },
    { name: 'Lançado Por', field: 'item.registrador', size: -1, sortable: 0, exportable: 0 },
    { name: 'Em', field: 'formatDate(item.dataRegistro)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Baixado', field: '(item.baixado) ? "Sim" : "Não"', size: -1, sortable: 0, exportable: 0 },

];

const budgetColumns = [
    { name: 'Código', field: '(item.codigo) ? item.codigo : "..."', size: 150, sortable: 0, exportable: 0 },
    { name: 'Nome', field: 'item.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Tipo', field: '(item.origem) ? item.origem.nome : "??"', size: -1, sortable: 0, exportable: 0 },
    { name: 'Categoria', field: '(item.aplicacao) ? item.aplicacao.nome: "??"', size: -1, sortable: 0, exportable: 0 },
    { name: 'Qtd', field: 'formatDecimal(item.qtd)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Unidade', field: '(item.unidade) ? item.unidade.nome : "??"', size: -1, sortable: 0, exportable: 0 },
    { name: 'Material Unitário', field: 'formatDecimal(item.valor)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Mão Obra Unitária', field: 'formatDecimal(item.instalacao)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total Material', field: 'formatDecimal(item.qtd * item.valor)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total Mão Obra', field: ' formatDecimal(item.qtd * item.instalacao)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total', field: ' formatDecimal(((item.valor * item.qtd) + (item.instalacao * item.qtd)))', size: -1, sortable: 0, exportable: 0 }
];

const infraColumns = [
    { name: 'Nome', field: 'item.infraEstrutura.nome', size: 300, sortable: 0, exportable: 0 },
    { name: 'Tipo', field: 'item.infraEstrutura.tipo', size: 100, sortable: 0, exportable: 0 },
    { name: 'Qtd', field: 'formatNumber(item.qtd, "0")', size: -1, sortable: 0, exportable: 0 },
    { name: 'Observações', field: 'item.detalhes', size: 400, sortable: 0, exportable: 0 }
];

const equipmentColumns = [
    { name: 'Modelo', field: 'item.modelo', size: 300, sortable: 0, exportable: 0 },
    { name: 'Tipo', field: 'item.tipo.nome', size: 100, sortable: 0, exportable: 0 },
    { name: 'Marca', field: 'item.marca.nome', size: 200, sortable: 0, exportable: 0 },
    { name: 'Observações', field: 'item.observacoes', size: 400, sortable: 0, exportable: 0 }
];

const scheduleColumns = [
    { name: 'Data', field: 'formatDate(item.dataAgenda)', size: 100, sortable: 0, exportable: 0 },
    { name: 'Hora', field: 'item.hora', size: 100, sortable: 0, exportable: 0 },
    { name: 'Departamento', field: 'getName(item)', size: 260, sortable: 0, exportable: 0 },
    { name: 'Técnico', field: 'item.tecnico.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Auxiliar', field: 'item.auxiliar.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Veículo', field: 'item.veiculo', size: 150, sortable: 0, exportable: 0 },
    { name: 'Observação', field: 'item.observacao', size: -1, sortable: 0, exportable: 0 }
];

const actionsColumns = [
    { name: 'Data', field: 'formatDatetime(item.data)', size: 250, sortable: 0, exportable: 0 },
    { name: 'Descrição', field: 'item.descricao', size: -1, sortable: 0, exportable: 0 },
    { name: 'Registrado por', field: 'item.usuario', size: -1, sortable: 0, exportable: 0 }
];


const orderCpColumns = [
    { name: 'Nome', field: 'item.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Descrição', field: 'item.instrucoes', size: -1, sortable: 0, exportable: 0 },
    { name: 'Qtd', field: 'formatDecimal(item.qtd)', size: 100, sortable: 0, exportable: 0 },
    { name: 'Valor', field: 'formatDecimal(item.valor)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total', field: 'formatDecimal(parseFloat(item.valor * item.qtd))', size: -1, sortable: 0, exportable: 0 },
    { name: 'Unidade', field: '(item.unidade) ? item.unidade.nome : "??"', size: 100, sortable: 0, exportable: 0 },
    { name: 'Fornecedor', field: '(item.fornecedor) ? item.fornecedor.nome : "??"', size: -1, sortable: 0, exportable: 0 },
    { name: 'Solicitante', field: 'item.solicitante', size: 150, sortable: 0, exportable: 0 }
];

const orderPlanColumns = [
    { name: 'Nome', field: 'item.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Descrição', field: 'item.instrucoes', size: -1, sortable: 0, exportable: 0 },
    { name: 'Qtd', field: 'formatDecimal(item.qtd)', size: 100, sortable: 0, exportable: 0 },
    { name: 'Unidade', field: '(item.unidade) ? item.unidade.nome : "??"', size: 100, sortable: 0, exportable: 0 },
    { name: 'Solicitante', field: 'item.solicitante', size: 150, sortable: 0, exportable: 0 }
];

const infraEmptyMessage = "Nenhuma Infraestrutura foi Encontrada.";
const equipmentEmptyMessage = "Nenhum Equipamento foi Encontrado.";
const expensesEmptyMessage = "Nenhuma Despesa Foi Adicionada.";
const budgetEmptyMessage = "Nenhum Produto Foi Adicionado.";
const orderCpEmptyMessage = "Nenhum Produto foi Adicionado";
const orderPlanEmptyMessage = "Nenhum Produto foi Adicionado";
const scheduleEmptyMessage = "Nenhum Agendamento Foi Registrado.";
const actionsEmptyMessage = "Nenhuma Ação Foi Registrada.";

const expenseFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: expensesEmptyMessage,
    columns: expensesColumns
};

const expensesCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: expensesEmptyMessage,
    columns: expensesColumns
};

const budgetFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: budgetEmptyMessage,
    columns: budgetColumns
};

const budgetCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: budgetEmptyMessage,
    columns: budgetColumns
};

const orderCpFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: orderCpEmptyMessage,
    columns: orderCpColumns
};

const orderCpCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: orderCpEmptyMessage,
    columns: orderCpColumns
};

const orderPlanFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: orderPlanEmptyMessage,
    columns: orderPlanColumns
};

const orderPlanCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: orderPlanEmptyMessage,
    columns: orderPlanColumns
};

const infraFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: infraEmptyMessage,
    columns: infraColumns
};

const infraCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: infraEmptyMessage,
    columns: infraColumns
};

const equipmentFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_DISABLED,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: equipmentEmptyMessage,
    columns: equipmentColumns
};

const equipmentCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_DISABLED,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: equipmentEmptyMessage,
    columns: equipmentColumns
};

const scheduleFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: scheduleEmptyMessage,
    columns: scheduleColumns
};

const scheduleCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: scheduleEmptyMessage,
    columns: scheduleColumns
};

const actionsFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: actionsEmptyMessage,
    columns: actionsColumns
};

const actionsCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: actionsEmptyMessage,
    columns: actionsColumns
};


const infraResultModes = [infraFullMode, infraCompactMode];
const equipmentResultModes = [equipmentFullMode, equipmentCompactMode];
const expensesResultModes = [expenseFullMode, expensesCompactMode];
const budgetResultModes = [budgetFullMode, budgetCompactMode];
const orderCpResultModes = [orderCpFullMode, orderCpCompactMode];
const orderPlanResultModes = [orderPlanFullMode, orderPlanCompactMode];
const scheduleResultModes = [scheduleFullMode, scheduleCompactMode];
const actionsResultModes = [actionsFullMode, actionsCompactMode];

const defaultProductLpu = {
    codigo: null,
    nome: null,
    UNIDADE: null,
    valor: 0.0,
    instalacao: 0.0,
    APLICACAO: null,
    REGIAO: -1
}
const defaultProductExpense = {
    id: null,
    codigo: null,
    nome: null,
    marca: null,
    fornecedor: null,
    unidade: null,
    codigoFornecedor: null,
    observacao: null,
    custo: null,
    valor: null,
    instalacao: null,
    ativo: 1,
    controlado: 1,
    APLICACAO: null,
    TIPO: null,
    UNIDADE: null,
    imagem: null,
    estoque: null
}

const defaultProductExpenseDependencies = {
    loaded: false,
    brandings: [],
    providers: [],
    units: [],
    applications: [],
    types: []
}


const Occurrence = ({ item, open, closeEdition, selectedMode, dependencies, updateValues, openUpload, openDocumentEdition,
    openDeletionDocument, openVisitEdition, openDeletionVisit, appointments, updateBudgets, updateExpenses, slas,
    openInfraEdition, openEquipmentEdition, openActionEdition, openDeletionAction, updateProcessings, createOAT }) => {

    const classes = useStyles();
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [save, setSave] = useState(true);
    const [openFindProduct, setOpenFindProduct] = useState(false);
    const [openFindExpense, setOpenFindExpense] = useState(false);
    const [produto, setProduto] = useState({});
    const [openDeletionProductDialog, setOpenDeletionProductDialog] = useState(false);
    const [openDeletionItemOrdemDialog, setOpenDeletionItemOrdemDialog] = useState(false);
    const [openEditItemDialog, setOpenEditItemDialog] = useState(false);
    const [expense, setExpense] = useState({});
    const [openDeletionExpenseDialog, setOpenDeletionExpenseDialog] = useState(false);
    const [openDocuments, setOpenDocuments] = useState(true);
    const [value, setValue] = useState(0);

    const [openCreateProductDialog, setOpenCreateProductDialog] = useState(false);
    const [productLpu, setProductLpu] = useState(defaultProductLpu);

    const [openCreateExpenseProductDialog, setOpenCreateExpenseProductDialog] = useState(false);
    const [productExpense, setProductExpense] = useState(defaultProductExpense);
    const [productExpenseDependencies, setProductExpenseDependencies] = useState(defaultProductExpenseDependencies);

    const [itemOrdem, setItemOrdem] = useState({});

    const changeBudgetStatus = (orcamento) => {

    }

    const openCreateProduct = (values) => {
        setOpenCreateProductDialog(true)
    }

    const openCreateExpenseProduct = (values) => {
        setProductExpense(values);
        agm.post('/produtos/edicao', { values }, {}).then((response) => {
            if (!response.data.error) {
                setProductExpenseDependencies(
                    {
                        brandings: response.data.marcas,
                        providers: response.data.fornecedores,
                        units: response.data.unidades,
                        applications: response.data.aplicacoes,
                        types: response.data.tipos,
                        lpus: response.data.lpus
                    }
                );
                values.codigo = numeral(response.data.proximocodigo).format('0000');
                setProductExpense(values);
                setOpenCreateExpenseProductDialog(true);
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, info: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const createExpenseProductValues = (values) => {
        setProductExpense(values)
        agm.post('/produtos', values).then((response) => {
            if (!response.data.error) {
                values.expenseCodigo = response.data.produto.codigo;
                values.expenseNome = response.data.produto.nome;
                values.expenseTipo = response.data.produto.tipo.tipoDespesa.id;
                values.expenseNotaFornecedor = response.data.produto.fornecedor.id;
                values.expenseNota = '';
                values.expenseEstoque = 1;
                values.expenseQtd = 1;
                values.expenseCusto = numeral((response.data.produto.custo) ? response.data.produto.custo : 0).format('0.00');
                values.expenseValor = numeral((response.data.produto.instalacao) ? response.data.produto.instalacao : 0).format('0.00');
                values.expenseId = response.data.produto.id;
                values.produto = response.data.produto;
                closeCreateExpenseProduct();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, info: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const closeCreateExpenseProduct = () => {
        setOpenCreateExpenseProductDialog(false)
    }

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    const closeDeletionProduct = () => {
        setOpenDeletionProductDialog(false);
    }

    const closeDeletionItemOrdemDialog = () => {
        setOpenDeletionItemOrdemDialog(false)
    }

    const closeDeletionExpense = () => {
        setOpenDeletionExpenseDialog(false);
    }

    const closeFindProduct = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFindProduct(false);
    };


    const closeCreateProduct = () => {
        setOpenCreateProductDialog(false);
    };

    const closeFindExpense = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFindExpense(false);
    };

    const createBudget = (values) => {
        var orcamento = {
            numero: -1,
            dataCriacao: new Date(),
            valorMaoObra: 0.0,
            valorMaterial: 0.0,
            valorDesconto: 0.0,
            FASE_ORCAMENTO: 1,
            idOcorrencia: values.id,
            ORCAMENTISTA: values.budgetORCAMENTISTA,
            dataEnvio: values.budgetdataEnvio,
            foiExecutado: false,
            servicoExecutar: ""
        }
        agm.post('/orcamentos/inicializar', { orcamento: orcamento }).then((response) => {
            if (!response.data.error) {
                updateProcessings(values.id);
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const saveBudget = (values, dependencies) => {
        var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        var itens = dependencies.items;
        var orcamento = {
            id: values.budgetid,
            numero: values.budgetnumero,
            ocorrencia: values.ocorrencia,
            idOcorrencia: values.budgetOCORRENCIA,
            dataCriacao: values.budgetdataCriacao,
            dataEnvio: values.budgetdataEnvio,
            foiExecutado: values.budgetfoiExecutado,
            valorMaoObra: values.budgetvalorMaoObra,
            valorMaterial: values.budgetvalorMaterial,
            valorDesconto: values.budgetvalorDesconto,
            total: values.budgetvalortotal,
            FASE_ORCAMENTO: values.budgetFASE_ORCAMENTO,
            ORCAMENTISTA: values.budgetORCAMENTISTA,
            TECNICO: values.budgetTECNICO,
            atualizarPdf: values.atualizarPdf,
            chavePdf: values.chavePdf,
            servicoExecutar: values.budgetServicoExecutar
        };
        var removes = dependencies.removes;
        agm.put('/orcamentos/' + orcamento.id, { orcamento: orcamento, itens: itens, removes: removes, usuario: usuario }).then((response) => {
            if (!response.data.error) {
                updateBudgets(values, dependencies);
            }
            values.atualizarPdf = false;
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const getRandomId = () => {
        var min = Math.ceil(9900);
        var max = Math.floor(10000);
        return parseInt(Math.floor(Math.random() * (max - min + 1)) + min) * -1;
    };

    const selectProduct = (values, produto) => {
        values.idProduto = produto.id;
        values.qtdProduto = 1.0;
        values.codigoProduto = produto.codigo;
        values.nomeProduto = produto.nome;
        values.valorProduto = numeral((produto.valor) ? produto.valor : 0).format('0.00');
        values.instalacaoProduto = numeral((produto.instalacao) ? produto.instalacao : 0).format('0.00');
        values.origemProduto = 1;
        values.aplicacaoProduto = produto.APLICACAO;
        values.unidadeProduto = produto.UNIDADE;
        values.produto = produto;
        closeFindProduct();
    }

    const createProductLpuValues = (pdlpu, values) => {
        agm.post('/produtoslpu', pdlpu).then((response) => {
            if (!response.data.error) {

                values.idProduto = pdlpu.id;
                values.qtdProduto = 1.0;
                values.codigoProduto = pdlpu.codigo;
                values.nomeProduto = pdlpu.nome;
                values.valorProduto = numeral((pdlpu.valor) ? pdlpu.valor : 0).format('0.00');
                values.instalacaoProduto = numeral((pdlpu.instalacao) ? pdlpu.instalacao : 0).format('0.00');
                values.produto = pdlpu;

                for (let index = 0; index < dependencies.applications.length; index++) {
                    const applic = dependencies.applications[index];
                    if (applic.id == pdlpu.APLICACAO) {
                        values.produto.aplicacao = applic;
                    }
                }

                for (let index = 0; index < dependencies.units.length; index++) {
                    const unt = dependencies.units[index];
                    if (unt.id == pdlpu.UNIDADE) {
                        values.produto.unidade = unt;
                    }
                }

                document.getElementById('nomeProduto').focus();
                document.getElementById('qtdProduto').focus();

                closeCreateProduct();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const handleAddItemOc = (values) => {

        if (values.orderCpNome && values.orderCpQtd) {
            var itemOrdem = {
                ocorrencia: values.id,
                qtd: values.orderCpQtd,
                nome: values.orderCpNome,
                unidade: values.orderCpUnid,
                valor: values.orderCpVlr,
                fornecedor: values.orderCpFornec,
                instrucoes: values.orderCpInstruc,
                solicitante: localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname')
            }
            agm.post('/ocorrencias/itemordem', itemOrdem).then((response) => {
                values.orderCpNome = '';
                values.orderCpQtd = 1;
                values.orderCpUnid = '';
                values.orderCpVlr = 0.0,
                values.orderCpFornec = '',            
                values.orderCpInstruc = '';
                document.getElementById('orderCpQtd').focus();
                document.getElementById('orderCpNome').focus();
                setMessage(response.data);
                setOpenAlert(true);
                updateProcessings(values.id);
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: error.message });
                setOpenAlert(true);
            })

        }
    }

    const handleAddItemPlan = (values) => {

        if (values.orderPlanNome && values.orderPlanQtd) {
            var itemOrdem = {
                ocorrencia: values.id,
                qtd: values.orderPlanQtd,
                nome: values.orderPlanNome,
                unidade: values.orderPlanUnid,
                instrucoes: values.orderPlanInstruc,
                solicitante: localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname')
            }
            agm.post('/ocorrencias/itemplanejamento', itemOrdem).then((response) => {
                values.orderPlanNome = '';
                values.orderPlanQtd = 1;
                values.orderPlanUnid = '';
                values.orderPlanInstruc = '';
                document.getElementById('orderPlanQtd').focus();
                document.getElementById('orderPlanNome').focus();
                setMessage(response.data);
                setOpenAlert(true);
                updateProcessings(values.id);
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: error.message });
                setOpenAlert(true);
            })

        }
    }

    const clearFieldsOc = (values) => {
        values.orderCpNome = '';
        values.orderCpQtd = 1;
        values.orderCpUnid = '';
        values.orderCpVlr = 0.0;
        values.orderCpFornec = '';
        values.orderCpInstruc = '';
        document.getElementById('orderCpQtd').focus();
        document.getElementById('orderCpNome').focus();
    }

    const clearFieldsPlan = (values) => {
        values.orderPlanNome = '';
        values.orderPlanQtd = 1;
        values.orderPlanUnid = '';
        values.orderPlanInstruc = '';
        document.getElementById('orderPlanQtd').focus();
        document.getElementById('orderPlanNome').focus();
    }

    const clearFields = (values) => {
        values.idProduto = ''
        values.qtdProduto = '';
        values.codigoProduto = '';
        values.nomeProduto = '';
        values.lpuProduto = '';
        values.custoProduto = '';
        values.bdiProduto = '';
        values.valorProduto = '';
        values.instalacaoProduto = '';
        values.origemProduto = null;
        values.unidadeProduto = null;
        values.aplicacaoProduto = null;
        values.produto = null;
        document.getElementById('nomeProduto').focus();
        document.getElementById('codigoProduto').focus();
    }

    const handleAddItem = (values) => {
        if (values.nomeProduto) {
            dependencies.items.push({
                id: getRandomId(),
                qtd: values.qtdProduto,
                valor: values.valorProduto,
                instalacao: values.instalacaoProduto,
                total: (parseFloat(parseFloat(values.valorProduto) * parseFloat(values.qtdProduto)) + (parseFloat(parseFloat(values.instalacaoProduto) * parseFloat(values.qtdProduto)))),
                nome: values.nomeProduto,
                codigo: values.codigoProduto,
                unidade: values.unidadeProduto,
                aplicacao: values.aplicacaoProduto,
                origem: values.origemProduto,
                produto: values.idProduto
            });
            values.budgetvalorMaoObra = 0.0;
            values.budgetvalorMaterial = 0.0;
            values.budgetvalorDesconto = 0.0;
            for (let index = 0; index < dependencies.items.length; index++) {
                var prod = dependencies.items[index];
                values.budgetvalorMaoObra = (parseFloat(values.budgetvalorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
                values.budgetvalorMaterial = (parseFloat(values.budgetvalorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
            }
            values.budgetvalortotal = (parseFloat(values.budgetvalorMaoObra) + parseFloat(values.budgetvalorMaterial));
            values.idProduto = ''
            values.qtdProduto = '';
            values.codigoProduto = '';
            values.nomeProduto = '';
            values.lpuProduto = '';
            values.custoProduto = '';
            values.bdiProduto = '';
            values.valorProduto = '';
            values.instalacaoProduto = '';
            values.origemProduto = '';
            values.aplicacaoProduto = '';
            values.unidadeProduto = '';
            values.produto = null;
            saveBudget(values, dependencies);
            document.getElementById('nomeProduto').focus();
            document.getElementById('codigoProduto').focus();
        } else {
            setOpenFindProduct(true);
        }
    }

    const removeItem = (itemOrcamento, values) => {
        setProduto({ item: itemOrcamento, values, dependencies });
        setMessage({
            title: 'Item de Orçamento',
            message: 'Deseja excluir o item ' + itemOrcamento.nome + ' do Orçamento?',
            warn: 'Esta ação irá remover o item do orçamento e recalcular os valores. Caso o PDF já tenha sido gerado ele precisará ser atualizado selecionando a opção "Atualizar ou Gerar PDF do Orçamento ao Salvar".'
        });
        setOpenDeletionProductDialog(true);
    }

    const removeItemOrdem = (item, values) => {
        setItemOrdem(item)
        setMessage({
            title: 'Item de Ordem de Compra',
            message: 'Deseja excluir o item de Ordem de Compra "' + item.nome + '"?',
            warn: 'Esta ação irá remover o item de ordem de compra. Não será possível recuperar mais o item.'
        });
        setOpenDeletionItemOrdemDialog(true);
    }

    const editItem = (itemOrcamento, values) => {
        setProduto({ item: itemOrcamento, values, dependencies });
        setOpenEditItemDialog(true);
    }

    const updateItemvalues = (item, values) => {
        agm.put('/orcamentos/item/' + item.id, { item: item }).then((response) => {
            if (!response.data.erroitemr) {
                updateProcessings(values.id);
            }
            setOpenEditItemDialog(false);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const saveExpenses = (values, dependencies) => {
        var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        var itens = dependencies.expenses;
        var removes = dependencies.removes;
        agm.put('/ocorrencias/despesas/' + values.id, { itens: itens, removes: removes, usuario: usuario }).then((response) => {
            if (!response.data.error) {
                updateExpenses(values, dependencies);
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const selectExpense = (values, despesa, estoque) => {
        if (despesa) {
            values.expenseCodigo = despesa.codigo;
            values.expenseNome = despesa.nome;
            values.expenseTipo = despesa.tipo.tipoDespesa;
            values.expenseNotaFornecedor = despesa.fornecedor;
            values.expenseNota = '';
            values.expenseEstoque = estoque;
            values.expenseQtd = 1;
            values.expenseCusto = numeral((despesa.custo) ? despesa.custo : 0).format('0.00');
            values.expenseValor = numeral((despesa.custo) ? despesa.custo : 0).format('0.00');
            values.expenseId = despesa.id;
            values.produto = despesa;
            values.expenseProvider = "";
            closeFindExpense();
        }
    }

    const isNewExpenseItem = (values) => {
        var vlr = values.expenseNome && values.expenseQtd && values.expenseValor;
        if (values.expenseNome && values.expenseQtd && values.expenseValor) {
            values.expenseCusto = values.expenseValor;
        }
        return vlr
    }

    const getTipoDespesa = (dependencies, values) => {
        var tp = values.expenseTipo;
        if (tp) {
            for (let index = 0; index < dependencies.expensesType.length; index++) {
                const element = dependencies.expensesType[index];
                if (element.id == tp) {
                    return element;
                }
            }
        }
        return tp;
    }

    const getFornecedor = (dependencies, values) => {
        if (values.expenseNotaFornecedor) {
            for (let index = 0; index < dependencies.expensesProvider.length; index++) {
                const element = dependencies.expensesProvider[index];
                if (element.id === values.expenseNotaFornecedor) {
                    return element;
                }

            }
        }
        return values.expenseNotaFornecedor;
    }

    const handleAddExpense = (values) => {
        if (values.expenseId || isNewExpenseItem(values)) {
            var newItemExpense = {
                id: getRandomId(),
                qtd: values.expenseQtd,
                valor: values.expenseValor,
                custo: values.expenseCusto,
                codigo: (values.produto && values.produto.codigo) ? values.produto.codigo : '----',
                nome: (values.produto && values.produto.nome) ? values.produto.nome : values.expenseNome,
                produto: (values.produto) ? values.produto : null,
                estoque: values.expenseEstoque,
                tipo: getTipoDespesa(dependencies, values),
                nota: values.expenseNota,
                fornecedor: getFornecedor(dependencies, values),
                registrador: (localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname'))
            };
            dependencies.expenses.push(newItemExpense);
            values.expenseTotalCustos = 0.0;
            values.expenseTotalDespesas = 0.0;
            for (let index = 0; index < dependencies.expenses.length; index++) {
                var expense = dependencies.expenses[index];
                values.expenseTotalCustos = values.expenseTotalCustos + (expense.custo * expense.qtd);
                values.expenseTotalDespesas = values.expenseTotalDespesas + (expense.valor * expense.qtd);
            }
            values.expenseCodigo = '';
            values.expenseNome = '';
            values.expenseTipo = 1;
            values.expenseNotaFornecedor = '';
            values.expenseNota = '';
            values.expenseQtd = '';
            values.expenseCusto = '';
            values.expenseValor = '';
            values.expenseEstoque = '';
            values.expenseId = '';
            values.produto = {};
            saveExpenses(values, dependencies);
            document.getElementById('expenseCodigo').focus();
        } else {
            setOpenFindExpense(true);
        }
    }

    const removeExpense = (itemExpense, values) => {
        setExpense({ item: itemExpense, values, dependencies });
        setMessage({
            title: 'Despesa da Ocorrência',
            message: 'Deseja excluir a despesa ' + itemExpense.nome + '?',
            warn: 'Esta ação irá remover a despesa da ocorrência e recalcular os valores.'
        });
        setOpenDeletionExpenseDialog(true);
    }

    const handleRemoveExpense = (value) => {
        var { item, values, dependencies } = value;
        for (let index = 0; index < dependencies.expenses.length; index++) {
            var desp = dependencies.expenses[index];
            if (desp.id == item.id) {
                dependencies.expenses.splice(index, 1);
                dependencies.removes.push(desp);
                break;
            }
        }
        values.expenseTotalCustos = 0.0;
        values.expenseTotalDespesas = 0.0;
        for (let index = 0; index < dependencies.expenses.length; index++) {
            var expense = dependencies.expenses[index];
            values.expenseTotalCustos = values.expenseTotalCustos + (expense.custo * expense.qtd);
            values.expenseTotalDespesas = values.expenseTotalDespesas + (expense.valor * expense.qtd);
        }
        document.getElementById('expenseCodigo').focus();
        document.getElementById('expenseNome').focus();
        saveExpenses(values, dependencies);
        closeDeletionExpense();
        document.getElementById('expenseCodigo').focus();
    }

    const handleRemoveItem = (produto) => {
        var { item, values, dependencies } = produto;
        for (let index = 0; index < dependencies.items.length; index++) {
            var prod = dependencies.items[index];
            if (prod.id == item.id) {
                dependencies.items.splice(index, 1);
                dependencies.removes.push(item);
                break;
            }
        }
        values.budgetvalorMaoObra = 0.0;
        values.budgetvalorMaterial = 0.0;
        for (let index = 0; index < dependencies.items.length; index++) {
            prod = dependencies.items[index];
            values.budgetvalorMaoObra = (parseFloat(values.budgetvalorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
            values.budgetvalorMaterial = (parseFloat(values.budgetvalorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
        }
        values.budgetvalortotal = (parseFloat(values.budgetvalorMaoObra) + parseFloat(values.budgetvalorMaterial) - parseFloat(values.budgetvalorDesconto));
        document.getElementById('codigoProduto').focus();
        document.getElementById('nomeProduto').focus();
        saveBudget(values, dependencies);
        closeDeletionProduct();
        document.getElementById('codigoProduto').focus();
    }


    const handleRemoveItemOrdem = (itemOrdem) => {
        agm.post('/ocorrencias/removeitemordem', itemOrdem).then((response) => {
            closeDeletionItemOrdemDialog()
            setMessage(response.data);
            setOpenAlert(true);
            updateProcessings(itemOrdem.ocorrencia);
        }).catch((error) => {
            closeDeletionItemOrdemDialog()
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })

    }

    const handleAperture = (value, values) => {
        dependencies.symptomes.map(function (symptom) {
            if (symptom.id === values.symptom) {
                var estimativa = getEstimatedDays(symptom);
                if (estimativa > 0) {
                    var atendance = getEstimatedDaysAtendance(symptom);
                    var conclusion = getestimatedDaysConclusion(symptom);
                    values.dateFirstAtend = moment(new Date(value)).add(atendance, 'days');
                    values.dateConclusion = moment(new Date(value)).add(atendance + conclusion, 'days');
                    setMessage({
                        error: true,
                        warn: true,
                        detail: 'Atenção! Datas de SLA foram atualizadas no ATENDIMENTO.'
                    });
                    setOpenAlert(true);
                }
            }
        });
    }

    const handleSymptom = (event, values) => {
        dependencies.symptomes.map(function (symptom) {
            if (event.target.value === symptom.id) {
                var estimativa = getEstimatedDays(symptom);
                if (estimativa > 0) {
                    var atendance = getEstimatedDaysAtendance(symptom);
                    var conclusion = getestimatedDaysConclusion(symptom);
                    values.dateFirstAtend = moment(values.dateAperture).add(atendance, 'days');
                    values.dateConclusion = moment(values.dateAperture).add(atendance + conclusion, 'days');
                } else {
                    values.dateFirstAtend = null;
                    values.dateConclusion = null;
                }
            }
        });
    }

    const getEstimatedDaysAtendance = (symptom) => {
        if (symptom.slaAtendimento) {
            var atendimento = symptom.vlrAtendimento;
            if (symptom.slaAtendimento == 'Mês') {
                atendimento = (symptom.vlrAtendimento * 30);
            }
            return atendimento;
        }
        return 0;
    }

    const getestimatedDaysConclusion = (symptom) => {
        if (symptom.slaConclusao) {
            var conclusao = symptom.vlrConclusao;
            if (symptom.slaConclusao == 'Mês') {
                conclusao = (symptom.vlrConclusao * 30);
            }
            return conclusao;
        }
        return 0;
    }

    const getEstimatedDays = (symptom) => {
        var conclusao = getestimatedDaysConclusion(symptom);
        var atendimento = getEstimatedDaysAtendance(symptom);
        var estimativa = (conclusao + atendimento);
        return estimativa;
    }

    const getSymptomName = (symptom) => {
        var estimativa = getEstimatedDays(symptom);
        if (estimativa > 0) {
            if (estimativa > 1) {
                estimativa += ' Dias';
            } else {
                estimativa += ' Dia';
            }
            return symptom.nome + ' [ SLA de ' + estimativa + ' ]';
        } else {
            return symptom.nome + ' [ Sem Estimativa de SLA ]';
        }
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    return (
        <Fragment>

            <Confirmations item={produto}
                message={message}
                open={openDeletionProductDialog}
                close={closeDeletionProduct}
                confirmation={handleRemoveItem} />

            <Confirmations item={itemOrdem}
                message={message}
                open={openDeletionItemOrdemDialog}
                close={closeDeletionItemOrdemDialog}
                confirmation={handleRemoveItemOrdem} />

            <Confirmations item={expense}
                message={message}
                open={openDeletionExpenseDialog}
                close={closeDeletionExpense}
                confirmation={handleRemoveExpense} />

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth  >
                <DialogTitle id="form-dialog-title">
                    <Taskbar item={item} slas={slas} title={`Ocorrência: ` + item.number + `, [ Agência: ` + item.code + ` - ` + item.name + ` ]`}></Taskbar>
                </DialogTitle>
                <DialogContent dividers>

                    <Formik
                        enableReinitialize
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                company: Yup.string().required('A seleção da emnpresa é obrigatória'),
                                contract: Yup.string().required('A seleção do contrato é obrigatória'),
                                dateAperture: Yup.date().required('A data de abertura da ocorrência é obrigatória'),
                                number: Yup.string().max(25).required('O número OT é obrigatório'),
                                //numbersa: Yup.string().max(15).required('O número SA é obrigatório'),
                                code: Yup.string().max(20).required('A seleção da unidade é obrigatória'),
                                name: Yup.string().required('O centro de custo não foi encontrado'),
                                companyStatus: Yup.string().required('A seleção do tipo de ocorrência é obrigatória'),
                                category: Yup.string().required('A seleção da categoria da ocorrência é obrigatória'),
                                atendType: Yup.string().required('A seleção de tipo de atendimento é obrigatória'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            saveBudget(values, dependencies);
                            updateValues(values, save);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit} >

                                <ItemOrcamento
                                    open={openEditItemDialog}
                                    closeEdition={() => { setOpenEditItemDialog(false) }}
                                    item={produto.item}
                                    updateValues={(item) => { updateItemvalues(item, values) }}
                                    dependencies={produto.dependencies}
                                />

                                <FindExpense open={openFindExpense}
                                    closeFind={closeFindExpense}
                                    selectExpense={selectExpense}
                                    values={values}
                                    selectMode={selectedMode}
                                />

                                <FindProductLpu open={openFindProduct}
                                    closeFind={closeFindProduct}
                                    selectProduct={selectProduct}
                                    values={values}
                                    selectMode={selectedMode}
                                    applications={dependencies.applications}
                                    region={dependencies.region}
                                />

                                <CreateProductLpu open={openCreateProductDialog}
                                    item={productLpu}
                                    dependencies={dependencies}
                                    selectMode={selectedMode}
                                    ocurrence={values}
                                    createValues={createProductLpuValues}
                                    closeCreation={closeCreateProduct} />

                                <CreateProductExpense item={productExpense}
                                    open={openCreateExpenseProductDialog}
                                    closeCreation={closeCreateExpenseProduct}
                                    createValues={createExpenseProductValues}
                                    dependencies={productExpenseDependencies}
                                />

                                <AppBar position="relative" >
                                    <Tabs
                                        value={value}
                                        onChange={handleChangeTab}
                                        aria-label="tabs"
                                        variant="scrollable"
                                        scrollButtons="auto">
                                        <Tab label="Abertura" {...a11yProps(0)} />
                                        <Tab label="Unidade" {...a11yProps(1)} />
                                        <Tab label="Agendamento" {...a11yProps(2)} />
                                        <Tab label="Planejamento" {...a11yProps(3)} />
                                        <Tab label="Ordem de Compra" {...a11yProps(4)} />
                                        <Tab label="Orçamento" {...a11yProps(5)} disabled={localStorage.getItem('profile') != 'ENG'} />
                                        <Tab label="Serviço" {...a11yProps(6)} />
                                        <Tab label="Despesa" {...a11yProps(7)} />
                                        <Tab label="Documentos" {...a11yProps(8)} />
                                    </Tabs>
                                </AppBar>

                                <TabPanel value={value} index={0} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid
                                                item
                                                md={1}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.number && errors.number)}
                                                    fullWidth
                                                    required
                                                    label="Número OT"
                                                    margin="none"
                                                    name="number"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.number}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={1}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.numbersa && errors.numbersa)}
                                                    fullWidth
                                                    required={false}
                                                    label="Número SA"
                                                    margin="none"
                                                    name="numbersa"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.numbersa}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: false, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink htmlFor="company" required >Cliente</InputLabel>
                                                    <Select notched
                                                        required
                                                        readOnly
                                                        error={Boolean(touched.company && errors.company)}
                                                        helperText={touched.company && errors.company}
                                                        value={values.company}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Cliente"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'company',
                                                            id: 'company',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.companies.map((company) => (
                                                            <MenuItem key={company.id} value={company.id}>{company.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink htmlFor="contract" required >Contrato</InputLabel>
                                                    <Select notched
                                                        required
                                                        error={Boolean(touched.contract && errors.contract)}
                                                        helperText={touched.contract && errors.contract}
                                                        value={values.contract}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Contrato"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'contract',
                                                            id: 'contract',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.contracts.map((contract) => (
                                                            <MenuItem key={contract.id} value={contract.id}>{contract.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    error={Boolean(touched.dateAperture && errors.dateAperture)}
                                                    required
                                                    cancelLabel="Cancelar"
                                                    margin="none"
                                                    inputVariant="outlined"
                                                    id="dateAperture"
                                                    label="Data de Abertura"
                                                    format="DD/MM/YYYY"
                                                    name="dateAperture"
                                                    value={values.dateAperture}
                                                    onBlur={handleBlur}
                                                    onChange={value => {
                                                        handleAperture(value, item);
                                                        setFieldValue("dateAperture", value);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>


                                                <Grid
                                                    container
                                                    spacing={2}
                                                >

                                                    <Grid
                                                        item
                                                        md={8}
                                                        xs={12}>

                                                        <Grid
                                                            container
                                                            spacing={2}
                                                        >

                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="occurrenceType" required >Tipo de Ocorrência</InputLabel>
                                                                    <Select notched
                                                                        required
                                                                        error={Boolean(touched.occurrenceType && errors.occurrenceType)}
                                                                        helperText={touched.occurrenceType && errors.occurrenceType}
                                                                        value={values.occurrenceType}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Tipo de Ocorrência"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'occurrenceType',
                                                                            id: 'occurrenceType',
                                                                        }}
                                                                    >
                                                                        <MenuItem value={null}>
                                                                            <em>Selecione uma das opções abaixo</em>
                                                                        </MenuItem>
                                                                        {dependencies.occurrenceTypes.map((occurrenceType) => (
                                                                            <MenuItem key={occurrenceType.id} value={occurrenceType.id}>{occurrenceType.nome}</MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="category" required >Categoria da Ocorrência</InputLabel>
                                                                    <Select notched
                                                                        required
                                                                        error={Boolean(touched.category && errors.category)}
                                                                        helperText={touched.category && errors.category}
                                                                        value={values.category}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Categoria da Ocorrência"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'category',
                                                                            id: 'category',
                                                                        }}
                                                                    >
                                                                        <MenuItem value={null}>
                                                                            <em>Selecione uma das opções abaixo</em>
                                                                        </MenuItem>
                                                                        {dependencies.categories.map((category) => (
                                                                            <MenuItem key={category.id} value={category.id}>{category.nome}</MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>


                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="invoiceType" required >Tipo de Nota</InputLabel>
                                                                    <Select notched
                                                                        required
                                                                        readOnly
                                                                        error={Boolean(touched.invoiceType && errors.invoiceType)}
                                                                        helperText={touched.invoiceType && errors.invoiceType}
                                                                        value={values.invoiceType}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Tipo de Nota"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'invoiceType',
                                                                            id: 'invoiceType',
                                                                        }}
                                                                    >
                                                                        <MenuItem value={null}>
                                                                            <em>Selecione uma das opções abaixo</em>
                                                                        </MenuItem>
                                                                        {dependencies.invoiceTypes.map((invoiceType) => (
                                                                            <MenuItem key={invoiceType.id} value={invoiceType.id}>{invoiceType.nome}</MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="atendType" required >Tipo de Atendimento</InputLabel>
                                                                    <Select notched
                                                                        required
                                                                        error={Boolean(touched.atendType && errors.atendType)}
                                                                        helperText={touched.atendType && errors.atendType}
                                                                        value={values.atendType}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Tipo de Atendimento"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'atendType',
                                                                            id: 'atendType',
                                                                        }}
                                                                    >
                                                                        <MenuItem value={null}>
                                                                            <em>Selecione uma das opções abaixo</em>
                                                                        </MenuItem>
                                                                        {dependencies.atendTypes.map((atendType) => (
                                                                            <MenuItem key={atendType.id} value={atendType.id}>{atendType.nome}</MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={12}
                                                                xs={12}
                                                            >
                                                                <TextField
                                                                    error={Boolean(touched.description && errors.description)}
                                                                    fullWidth
                                                                    required
                                                                    label="Descrição da Ocorrência"
                                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 8 : 3}
                                                                    length={1024}
                                                                    multiline
                                                                    margin="none"
                                                                    name="description"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.description}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    inputProps={
                                                                        { readOnly: false, }
                                                                    }
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={4}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="ocorrenceStatus" required >Fase ATM</InputLabel>
                                                                    <Select notched
                                                                        error={Boolean(touched.ocorrenceStatus && errors.ocorrenceStatus)}
                                                                        helperText={touched.ocorrenceStatus && errors.ocorrenceStatus}
                                                                        value={values.ocorrenceStatus}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Fase ATM"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'ocorrenceStatus',
                                                                            id: 'ocorrenceStatus',
                                                                        }}
                                                                    >
                                                                        {dependencies.ocorrenceStatusList.map((ocorrenceStatus) => (
                                                                            <MenuItem key={ocorrenceStatus.id} value={ocorrenceStatus.id}>{ocorrenceStatus.nome}</MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={5}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="companyStatus" required >Fase Cliente</InputLabel>
                                                                    <Select notched
                                                                        error={Boolean(touched.companyStatus && errors.companyStatus)}
                                                                        helperText={touched.companyStatus && errors.companyStatus}
                                                                        value={values.companyStatus}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Fase Cliente"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'companyStatus',
                                                                            id: 'companyStatus',
                                                                        }}
                                                                    >
                                                                        {dependencies.companyStatusList.map((companyStatus) => (
                                                                            <MenuItem key={companyStatus.id} value={companyStatus.id}>{companyStatus.nome}</MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>
                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <KeyboardDatePicker
                                                                    fullWidth
                                                                    required={values.companyStatus == 7}
                                                                    cancelLabel="Cancelar"
                                                                    margin="none"
                                                                    inputVariant="outlined"
                                                                    id="dateProtocol"
                                                                    label="Data de Entrega do Relatório"
                                                                    format="DD/MM/YYYY"
                                                                    name="dateProtocol"
                                                                    value={values.dateProtocol}
                                                                    onBlur={handleBlur}
                                                                    onChange={value => setFieldValue("dateProtocol", value)}
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change date',
                                                                    }}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={4}
                                                                xs={12}>

                                                                <FormControl variant="outlined" margin='none' fullWidth>
                                                                    <InputLabel shrink required={true} htmlFor="statusRevenues">Fase de Faturamento</InputLabel>
                                                                    <Select notched
                                                                        autosize={true}
                                                                        error={Boolean(touched.statusRevenues && errors.statusRevenues)}
                                                                        helperText={touched.statusRevenues && errors.statusRevenues}
                                                                        value={values.statusRevenues}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Fase de Faturamento"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'statusRevenues',
                                                                            id: 'statusRevenues',
                                                                        }}
                                                                    >
                                                                        <MenuItem value={null}>
                                                                            <em>Selecione uma das opções abaixo</em>
                                                                        </MenuItem>
                                                                        {dependencies.revenuesStatusList.map((statusRevenues) => (
                                                                            <MenuItem key={statusRevenues.id} value={statusRevenues.id}>{statusRevenues.nome}</MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={2}
                                                                xs={12}>

                                                                <FormControl variant="outlined" margin='none' fullWidth>
                                                                    <InputLabel shrink htmlFor="lote">Lote de Faturamento</InputLabel>
                                                                    <Select notched
                                                                        autosize={true}
                                                                        error={Boolean(touched.lote && errors.lote)}
                                                                        helperText={touched.lote && errors.lote}
                                                                        value={values.lote}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Lote de Faturamento"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'lote',
                                                                            id: 'lote',
                                                                            readOnly: true
                                                                        }}
                                                                    >
                                                                        <MenuItem value={null}>
                                                                            <em>Selecione uma das opções abaixo</em>
                                                                        </MenuItem>
                                                                        {dependencies.revenuesLoteList.map((loteRevenues) => (
                                                                            <MenuItem key={loteRevenues.id} value={loteRevenues.id}>{numeral(loteRevenues.codigo).format("000000")}</MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>


                                                        </Grid>
                                                    </Grid>

                                                    <Grid
                                                        item
                                                        md={4}
                                                        xs={12}>

                                                        <Grid
                                                            container
                                                            spacing={1}
                                                        >


                                                            <Grid
                                                                item
                                                                md={12}
                                                                xs={12}>

                                                                <Card  >
                                                                    <CardHeader title="Demonstrativo Financeiro" ></CardHeader>
                                                                    <Divider></Divider>
                                                                    <CardContent>
                                                                        <Box
                                                                            alignItems="center"
                                                                            display="flex"
                                                                            flexDirection="column"
                                                                        >
                                                                            <TableContainer component={Box}>
                                                                                <Table className={classes.table} aria-label="spanning table">
                                                                                    <TableBody>
                                                                                        <TableRow>
                                                                                            <TableCell>Valor Total do Orçamento</TableCell>
                                                                                            <TableCell align="right">{'+' + numeral(values.budgetvalortotal).format('0.00')}</TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell>Valor Total de Despesas</TableCell>
                                                                                            <TableCell align="right">{numeral(values.expenseTotalDespesas * -1).format('0.00')}</TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow style={((values.budgetvalortotal - values.expenseTotalDespesas) < 0) ? { backgroundColor: colors.red[500] } : { backgroundColor: colors.blue[500] }}>
                                                                                            <TableCell style={{ color: colors.common.white }}>Saldo</TableCell>
                                                                                            <TableCell style={{ color: colors.common.white }} align="right">{numeral(values.budgetvalortotal - values.expenseTotalDespesas).format('0.00')}</TableCell>
                                                                                        </TableRow>
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>

                                                                        </Box>
                                                                    </CardContent>
                                                                </Card>

                                                            </Grid>
                                                        </Grid>

                                                    </Grid>

                                                </Grid>

                                            </Grid>


                                        </Grid>
                                    </Box>

                                </TabPanel>

                                <TabPanel value={value} index={1} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.code && errors.code)}
                                                    fullWidth
                                                    required
                                                    label="Centro de Custo"
                                                    margin="none"
                                                    name="code"
                                                    id="code"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.code}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.name && errors.name)}
                                                    fullWidth
                                                    required
                                                    label="Nome"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    name="name"
                                                    id="name"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.name}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.address && errors.address)}
                                                    fullWidth
                                                    required
                                                    label="Endereço"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    name="address"
                                                    id="address"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.address}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.neighborhood && errors.neighborhood)}
                                                    fullWidth
                                                    required
                                                    label="Bairro"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    name="neighborhood"
                                                    id="neighborhood"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.neighborhood}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.city && errors.city)}
                                                    fullWidth
                                                    required
                                                    label="Cidade"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    name="city"
                                                    id="city"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.city}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md="auto"
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.typeUnit && errors.typeUnit)}
                                                    fullWidth
                                                    required
                                                    label="Tipo"
                                                    margin="none"
                                                    name="typeUnit"
                                                    id="typeUnit"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.typeUnit}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.engineer && errors.engineer)}
                                                    fullWidth
                                                    label="Engenheiro Responsável"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    id="engineer"
                                                    name="engineer"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.engineer}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.controller && errors.controller)}
                                                    fullWidth
                                                    label="Gerenciadora"
                                                    margin="none"
                                                    id="controller"
                                                    name="controller"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.controller}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.supervisor && errors.supervisor)}
                                                    fullWidth
                                                    label="Fiscal Responsável"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    id="supervisor"
                                                    name="supervisor"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.supervisor}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.region && errors.region)}
                                                    fullWidth
                                                    label="Rota"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    id="region"
                                                    name="region"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.region}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md="auto"
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.team && errors.team)}
                                                    fullWidth
                                                    label="Equipe Técnica"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    id="team"
                                                    name="team"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.team}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>



                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>

                                                <Grid
                                                    container
                                                    spacing={2}

                                                >

                                                    <Grid
                                                        item
                                                        md={6}
                                                        xs={12}>

                                                        <Box className={classes.infrascontainer}>
                                                            <Grid
                                                                container
                                                                spacing={2}
                                                            >

                                                                <Grid item
                                                                    md="12"
                                                                    xs="12"
                                                                >
                                                                    <Typography>Infraestrutura da Unidade</Typography>
                                                                    <ResultsInfra
                                                                        resultset={{
                                                                            loaded: true,
                                                                            records: dependencies.infras.length,
                                                                            pages: 1,
                                                                            page: 1,
                                                                            count: dependencies.infras.length,
                                                                            rows: dependencies.infras
                                                                        }}
                                                                        resultModes={infraResultModes}
                                                                        icon={MdOutlineMapsHomeWork}
                                                                        vision={{}}
                                                                        selectedMode={selectedMode}
                                                                        openEdition={openInfraEdition}
                                                                        openDeletion={() => { }}
                                                                        openTreatment={() => { }}
                                                                        openExportDialog={false}
                                                                        values={values}
                                                                    />

                                                                </Grid>

                                                            </Grid>
                                                        </Box>

                                                    </Grid>

                                                    <Grid
                                                        item
                                                        md={6}
                                                        xs={12}>

                                                        <Box className={classes.infrascontainer}>
                                                            <Grid
                                                                container
                                                                spacing={2}
                                                            >

                                                                <Grid item
                                                                    md="12"
                                                                    xs="12"
                                                                >
                                                                    <Typography>Equipamentos da Unidade</Typography>
                                                                    <ResultsEquipment
                                                                        resultset={{
                                                                            loaded: true,
                                                                            records: dependencies.equipments.length,
                                                                            pages: 1,
                                                                            page: 1,
                                                                            count: dependencies.equipments.length,

                                                                            rows: dependencies.equipments
                                                                        }}
                                                                        resultModes={equipmentResultModes}
                                                                        icon={BsHddNetworkFill}
                                                                        vision={{}}
                                                                        selectedMode={selectedMode}
                                                                        openEdition={openEquipmentEdition}
                                                                        openDeletion={() => { }}
                                                                        openTreatment={() => { }}
                                                                        openExportDialog={false}
                                                                        values={values}
                                                                    />

                                                                </Grid>

                                                            </Grid>
                                                        </Box>

                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                        </Grid>
                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={2} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.region && errors.region)}
                                                    fullWidth
                                                    label="Rota"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    id="region"
                                                    name="region"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.region}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.team && errors.team)}
                                                    fullWidth
                                                    label="Equipe Técnica"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    id="team"
                                                    name="team"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.team}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    required
                                                    error={Boolean(touched.dateFirstAtend && errors.dateFirstAtend)}
                                                    cancelLabel="Cancelar"
                                                    margin="none"
                                                    inputVariant="outlined"
                                                    id="dateFirstAtend"
                                                    label="Limite 1º Atendimento - CPA"
                                                    format="DD/MM/YYYY"
                                                    name="dateFirstAtend"
                                                    value={values.dateFirstAtend}
                                                    onBlur={handleBlur}
                                                    onChange={value => setFieldValue("dateFirstAtend", value)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={1}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.timelimcpa && errors.timelimcpa)}
                                                    fullWidth
                                                    label="Hora Limite CPA"
                                                    type="time"
                                                    margin="none"
                                                    id="timelimcpa"
                                                    name="timelimcpa"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.timelimcpa}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: false, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    required
                                                    error={Boolean(touched.dateConclusion && errors.dateConclusion)}
                                                    cancelLabel="Cancelar"
                                                    margin="none"
                                                    inputVariant="outlined"
                                                    id="dateConclusion"
                                                    label="Limite Conclusão - CPC"
                                                    format="DD/MM/YYYY"
                                                    name="dateConclusion"
                                                    value={values.dateConclusion}
                                                    onBlur={handleBlur}
                                                    onChange={value => setFieldValue("dateConclusion", value)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={1}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.timelimcpc && errors.timelimcpc)}
                                                    fullWidth
                                                    label="Hora Limite CPC"
                                                    type="time"
                                                    margin="none"
                                                    id="timelimcpc"
                                                    name="timelimcpc"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.timelimcpc}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: false, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={5}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink htmlFor="symptom" required >Sintoma</InputLabel>
                                                    <Select
                                                        rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                        multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}

                                                        notched
                                                        required
                                                        error={Boolean(touched.symptom && errors.symptom)}
                                                        helperText={touched.symptom && errors.symptom}
                                                        value={values.symptom}
                                                        onChange={e => {
                                                            handleSymptom(e, values);
                                                            handleChange(e);
                                                        }}
                                                        onBlur={handleBlur}
                                                        label="Sintoma"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'symptom',
                                                            id: 'symptom',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.symptomes.map((symptom) => (
                                                            <MenuItem key={symptom.id} value={symptom.id}>
                                                                {getSymptomName(symptom)}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink htmlFor="symptomLocal" required >Localização do Sintoma</InputLabel>
                                                    <Select
                                                        notched
                                                        required
                                                        error={Boolean(touched.symptomLocal && errors.symptomLocal)}
                                                        helperText={touched.symptomLocal && errors.symptomLocal}
                                                        value={values.symptomLocal}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Localização do Sintoma"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'symptomLocal',
                                                            id: 'symptomLocal',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.symptomLocals.map((symptomLocal) => (
                                                            <MenuItem key={symptomLocal.id} value={symptomLocal.id}>{symptomLocal.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>


                                            <Grid item
                                                md="auto"
                                                xs="auto">

                                                <Grid item
                                                    xs="auto">
                                                    <Button
                                                        color="secondary"
                                                        disabled={isSubmitting}
                                                        size="small"
                                                        variant="contained"
                                                        startIcon={<ImFilePdf />}
                                                        onClick={() => { createOAT(values) }}>
                                                        Gerar Ordem de Atendimento
                                                    </Button>
                                                </Grid>


                                            </Grid>


                                            <Grid item
                                                md={12}
                                                xs={12}>

                                                <Grid item
                                                    xs="auto">
                                                    <Button
                                                        color="secondary"
                                                        disabled={isSubmitting}
                                                        size="small"
                                                        variant="contained"
                                                        startIcon={<BsFillCalendarDateFill />}
                                                        onClick={() => { openVisitEdition({ id: null, ocorrencia: values.id, abertura: values.dateAperture, dataAgenda: '' }) }}>
                                                        Adicionar Agendamento
                                                    </Button>
                                                </Grid>


                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>
                                                <ResultsSchedule
                                                    resultSet={{
                                                        loaded: true,
                                                        records: dependencies.visits.length,
                                                        pages: 1,
                                                        page: 1,
                                                        count: dependencies.visits.length,
                                                        rows: dependencies.visits
                                                    }}
                                                    resultModes={scheduleResultModes}
                                                    icon={BsFillCalendarDateFill}
                                                    vision={{}}
                                                    selectedMode={selectedMode}
                                                    openEdition={openVisitEdition}
                                                    openDeletion={openDeletionVisit}
                                                    openTreatment={() => { }}
                                                    openExportDialog={false}
                                                    values={values}
                                                    appointments={appointments}
                                                />

                                            </Grid>
                                        </Grid>

                                    </Box>
                                </TabPanel>


                                <TabPanel value={value} index={3} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            className={classes.doned}
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label="Resumo do Serviço"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 2}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    name="planDesc"
                                                    id="planDesc"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.planDesc}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>

                                                <Card>
                                                    <CardContent>

                                                        <Grid container
                                                            direction="row"
                                                            justifyContent='flex-start'
                                                            alignItems="center"
                                                            spacing={2}  >

                                                            <Grid
                                                                item
                                                                md={4}
                                                                xs={12}>

                                                                <TextField
                                                                    fullWidth
                                                                    label="Nome"
                                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 1}
                                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                                    margin="none"
                                                                    name="orderPlanNome"
                                                                    id="orderPlanNome"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.orderPlanNome}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={4}
                                                                xs={12}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Descrição"
                                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 1}
                                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                                    margin="none"
                                                                    name="orderPlanInstruc"
                                                                    id="orderPlanInstruc"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.orderPlanInstruc}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Qtd"
                                                                    margin="none"
                                                                    name="orderPlanQtd"
                                                                    id="orderPlanQtd"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.orderPlanQtd}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth margin="none">
                                                                    <InputLabel shrink htmlFor="unidadeProduto" >Unidade</InputLabel>
                                                                    <Select notched
                                                                        autosize={true}
                                                                        value={values.orderPlanUnid}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Unidade"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'orderPlanUnid',
                                                                            id: 'orderPlanUnid',
                                                                        }}
                                                                    >
                                                                        <MenuItem key={-1} value={null}>
                                                                            <em>Selecione uma</em>
                                                                        </MenuItem>

                                                                        {dependencies.units.map((untss) => (
                                                                            <MenuItem key={untss.id} value={untss}>
                                                                                {untss.nome}
                                                                            </MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>


                                                            <Grid item
                                                                md="auto"
                                                                xs={12}>

                                                                <Button
                                                                    color="secondary"
                                                                    size="medium"
                                                                    variant="contained"
                                                                    startIcon={<FaClipboardList />}
                                                                    onBlur={handleBlur}
                                                                    onClick={() => { handleAddItemPlan(values) }}>
                                                                    Adicionar
                                                                </Button>
                                                            </Grid>

                                                            <Grid item
                                                                md="auto"
                                                                xs={12}
                                                                fullWidth>
                                                                <IconButton
                                                                    color="secondary"
                                                                    variant="contained"
                                                                    children={<AiOutlineClear />}
                                                                    size="small"
                                                                    onClick={() => { clearFieldsPlan(values) }}>
                                                                </IconButton>
                                                            </Grid>

                                                        </Grid>

                                                        <br></br>

                                                        <Grid container
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="center"
                                                            spacing={1}  >

                                                            <Grid item
                                                                md={12}
                                                                xs={12}>

                                                                <ResultsPlanejamento
                                                                    resultset={{
                                                                        loaded: true,
                                                                        records: dependencies.plans.length,
                                                                        pages: 1,
                                                                        page: 1,
                                                                        count: dependencies.plans.length,
                                                                        rows: dependencies.plans
                                                                    }}
                                                                    resultModes={orderPlanResultModes}
                                                                    icon={FaClipboardList}
                                                                    vision={{}}
                                                                    selectedMode={selectedMode}

                                                                    openEdition={(itemdesp) => {
                                                                        editItem(itemdesp, values);
                                                                    }}

                                                                    openDeletion={(itemdesp) => {
                                                                        removeItemOrdem(itemdesp, values);
                                                                    }}

                                                                    openTreatment={() => { }}
                                                                    openExportDialog={false}
                                                                    values={values}
                                                                />

                                                            </Grid>

                                                        </Grid>

                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={4} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            className={classes.doned}
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label="Instruções para compra"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 2}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    name="orderDesc"
                                                    id="orderDesc"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.orderDesc}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>

                                                <Card>
                                                    <CardContent>

                                                        <Grid container
                                                            direction="row"
                                                            justifyContent='flex-start'
                                                            alignItems="center"
                                                            spacing={2}  >

                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <TextField
                                                                    fullWidth
                                                                    label="Nome"
                                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 1}
                                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                                    margin="none"
                                                                    name="orderCpNome"
                                                                    id="orderCpNome"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.orderCpNome}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                style={{width: 400}}
                                                                md={3}
                                                                xs={12}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Descrição"
                                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 1}
                                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                                    margin="none"
                                                                    name="orderCpInstruc"
                                                                    id="orderCpInstruc"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.orderCpInstruc}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Qtd"
                                                                    margin="none"
                                                                    name="orderCpQtd"
                                                                    id="orderCpQtd"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.orderCpQtd}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Valor"
                                                                    margin="none"
                                                                    name="orderCpVlr"
                                                                    id="orderCpVlr"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.orderCpVlr}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth margin="none">
                                                                    <InputLabel shrink htmlFor="orderCpUnid" >Unidade</InputLabel>
                                                                    <Select notched
                                                                        autosize={true}
                                                                        value={values.orderCpUnid}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Unidade"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'orderCpUnid',
                                                                            id: 'orderCpUnid',
                                                                        }}
                                                                    >
                                                                        <MenuItem key={-1} value={null}>
                                                                            <em>Selecione uma</em>
                                                                        </MenuItem>

                                                                        {dependencies.units.map((untss) => (
                                                                            <MenuItem key={untss.id} value={untss}>
                                                                                {untss.nome}
                                                                            </MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={2}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth margin="none">
                                                                    <InputLabel shrink htmlFor="orderCpFornec" >Fornecedor</InputLabel>
                                                                    <Select notched
                                                                        autosize={true}
                                                                        value={values.orderCpFornec}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Unidade"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'orderCpFornec',
                                                                            id: 'orderCpFornec',
                                                                        }}
                                                                    >
                                                                        <MenuItem key={-1} value={null}>
                                                                            <em>Selecione uma</em>
                                                                        </MenuItem>

                                                                        {dependencies.expensesProvider.map((untss) => (
                                                                            <MenuItem key={untss.id} value={untss}>
                                                                                {untss.nome}
                                                                            </MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid item
                                                                md={1}
                                                                xs={12}>

                                                                <Button
                                                                    color="secondary"
                                                                    size="medium"
                                                                    variant="contained"
                                                                    startIcon={<FaClipboardList />}
                                                                    onBlur={handleBlur}
                                                                    onClick={() => { handleAddItemOc(values) }}>
                                                                    Adicionar
                                                                </Button>

                                                            </Grid>

                                                        </Grid>

                                                        <br></br>

                                                        <Grid container
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="center"
                                                            spacing={1}  >

                                                            <Grid item
                                                                md={12}
                                                                xs={12}>

                                                                <ResultsOrdemCompra
                                                                    resultset={{
                                                                        loaded: true,
                                                                        records: dependencies.orders.length,
                                                                        pages: 1,
                                                                        page: 1,
                                                                        count: dependencies.orders.length,
                                                                        rows: dependencies.orders
                                                                    }}
                                                                    resultModes={orderCpResultModes}
                                                                    icon={FaClipboardList}
                                                                    vision={{}}
                                                                    selectedMode={selectedMode}

                                                                    openEdition={(itemdesp) => {
                                                                        editItem(itemdesp, values);
                                                                    }}

                                                                    openDeletion={(itemdesp) => {
                                                                        removeItemOrdem(itemdesp, values);
                                                                    }}

                                                                    openTreatment={() => { }}
                                                                    openExportDialog={false}
                                                                    values={values}
                                                                />

                                                            </Grid>

                                                        </Grid>

                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={5} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={1}
                                            className={classes.doned}
                                        >


                                            <Grid item
                                                md="auto"
                                                xs={12}>

                                                <Button
                                                    disabled={values.budgetid}
                                                    id="btninicializar"
                                                    color="secondary"
                                                    size="medium"
                                                    variant="contained"
                                                    startIcon={<FaMoneyBillWave />}
                                                    onBlur={handleBlur}
                                                    onClick={() => { createBudget(values) }}>
                                                    Criar Orçamento
                                                </Button>
                                            </Grid>

                                            <Grid
                                                item
                                                md="auto"
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.budgetnumero && errors.budgetnumero)}
                                                    fullWidth
                                                    required={false}
                                                    label="Orçamento"
                                                    margin="none"
                                                    name="budgetnumero"
                                                    id="budgetnumero"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={(values.budgetnumero) ? numeral(values.budgetnumero).format('000000') : ''}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    required={(values.budgetnumero)}
                                                    readOnly
                                                    cancelLabel="Cancelar"
                                                    margin="none"
                                                    inputVariant="outlined"
                                                    id="budgetdataCriacao"
                                                    label="Data de Criação"
                                                    format="DD/MM/YYYY"
                                                    name="budgetdataCriacao"
                                                    value={values.budgetdataCriacao}
                                                    onBlur={handleBlur}
                                                    onChange={value => setFieldValue("budgetdataCriacao", value)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink htmlFor="budgetFASE_ORCAMENTO" required={(values.budgetnumero)} >Fase de Orçamento</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required={(values.budgetnumero)}
                                                        readOnly
                                                        error={Boolean(touched.budgetFASE_ORCAMENTO && errors.budgetFASE_ORCAMENTO)}
                                                        helperText={touched.budgetFASE_ORCAMENTO && errors.budgetFASE_ORCAMENTO}
                                                        value={values.budgetFASE_ORCAMENTO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Fase de Orçamento"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'budgetFASE_ORCAMENTO',
                                                            id: 'budgetFASE_ORCAMENTO',
                                                        }}
                                                    >
                                                        <MenuItem key={-1} value={null}>
                                                            <em>Selecione um</em>
                                                        </MenuItem>

                                                        {dependencies.phases.map((phase) => (
                                                            <MenuItem key={phase.id} value={phase.id}>{phase.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid item>
                                                <IconButton
                                                    color="secondary"
                                                    disabled={!values.budgetid}
                                                    children={<BuildIcon />}
                                                    size="medium"
                                                    onClick={() => { changeBudgetStatus(values.budgetid) }}>
                                                </IconButton>
                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink htmlFor="budgetORCAMENTISTA" required={(values.budgetnumero)} >Orçamentista</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required={(values.budgetnumero)}
                                                        error={Boolean(touched.budgetORCAMENTISTA && errors.budgetORCAMENTISTA)}
                                                        helperText={touched.budgetORCAMENTISTA && errors.budgetORCAMENTISTA}
                                                        value={values.budgetORCAMENTISTA}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Orçamentista"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'budgetORCAMENTISTA',
                                                            id: 'budgetORCAMENTISTA',
                                                        }}
                                                    >
                                                        <MenuItem key={-1} value={null}>
                                                            <em>Selecione um</em>
                                                        </MenuItem>

                                                        {dependencies.makers.map((maker) => (
                                                            <MenuItem key={maker.id} value={maker.id}>{maker.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    cancelLabel="Cancelar"
                                                    margin="none"
                                                    inputVariant="outlined"
                                                    id="budgetdataEnvio"
                                                    label="Data de Envio"
                                                    format="DD/MM/YYYY"
                                                    name="budgetdataEnvio"
                                                    value={values.budgetdataEnvio}
                                                    onBlur={handleBlur}
                                                    onChange={value => setFieldValue("budgetdataEnvio", value)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}
                                            >
                                                <TextField
                                                    error={Boolean(touched.budgetServicoExecutar && errors.budgetServicoExecutar)}
                                                    required={(values.budgetnumero)}
                                                    fullWidth
                                                    label="Serviços a serem executados"
                                                    maxRows={2}
                                                    minRows={1}
                                                    length={1024}
                                                    multiline
                                                    margin="none"
                                                    name="budgetServicoExecutar"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.budgetServicoExecutar}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={
                                                        { readOnly: false, }
                                                    }
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>

                                                <Card>
                                                    <CardContent>

                                                        <Grid container
                                                            direction="row"
                                                            justifyContent='flex-start'
                                                            alignItems="center"
                                                            spacing={2}  >

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>

                                                                <TextField
                                                                    fullWidth
                                                                    label="Código"
                                                                    margin="none"
                                                                    name="codigoProduto"
                                                                    id="codigoProduto"
                                                                    onBlur={e => {
                                                                        handleBlur(e);
                                                                    }}
                                                                    onChange={handleChange}
                                                                    value={values.codigoProduto}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <TextField
                                                                    fullWidth
                                                                    label="Nome"
                                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 4 : 1}
                                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                                    margin="none"
                                                                    name="nomeProduto"
                                                                    id="nomeProduto"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.nomeProduto}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Qtd"
                                                                    margin="none"
                                                                    name="qtdProduto"
                                                                    id="qtdProduto"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.qtdProduto}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md="auto"
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth margin="none">
                                                                    <InputLabel shrink htmlFor="unidadeProduto" >Unidade</InputLabel>
                                                                    <Select notched
                                                                        style={{ width: 100 }}
                                                                        autosize={true}
                                                                        value={values.unidadeProduto}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Unidade"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'unidadeProduto',
                                                                            id: 'unidadeProduto',
                                                                        }}
                                                                    >
                                                                        <MenuItem key={-1} value={null}>
                                                                            <em>Selecione uma</em>
                                                                        </MenuItem>

                                                                        {dependencies.units.map((untss) => (
                                                                            <MenuItem key={untss.id} value={untss.id}>
                                                                                {untss.nome}
                                                                            </MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md="auto"
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth margin="none">
                                                                    <InputLabel shrink htmlFor="origemProduto" >Tipo</InputLabel>
                                                                    <Select notched
                                                                        style={{ width: 180 }}
                                                                        autosize={true}
                                                                        value={values.origemProduto}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Tipo"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'origemProduto',
                                                                            id: 'origemProduto',
                                                                        }}
                                                                    >
                                                                        <MenuItem key={-1} value={null}>
                                                                            <em>Selecione uma</em>
                                                                        </MenuItem>


                                                                        {dependencies.origins.map((orgins) => (
                                                                            <MenuItem key={orgins.id} value={orgins.id}>
                                                                                {orgins.nome}
                                                                            </MenuItem>
                                                                        ))}


                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md="auto"
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth margin="none">
                                                                    <InputLabel shrink htmlFor="aplicacaoProduto" >Categoria</InputLabel>
                                                                    <Select notched
                                                                        style={{ width: 180 }}
                                                                        autosize={true}
                                                                        value={values.aplicacaoProduto}
                                                                        onChange={e => {
                                                                            handleChange(e);
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        label="Categoria"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'aplicacaoProduto',
                                                                            id: 'aplicacaoProduto',
                                                                        }}
                                                                    >
                                                                        <MenuItem key={-1} value={null}>
                                                                            <em>Selecione uma</em>
                                                                        </MenuItem>

                                                                        {dependencies.applications.map((applsprd) => (
                                                                            <MenuItem key={applsprd.id} value={applsprd.id}>
                                                                                {applsprd.nome}
                                                                            </MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Valor Material"
                                                                    margin="none"
                                                                    name="valorProduto"
                                                                    id="valorProduto"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.valorProduto}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Valor Mão Obra"
                                                                    margin="none"
                                                                    name="instalacaoProduto"
                                                                    id="instalacaoProduto"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.instalacaoProduto}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid item
                                                                md="auto"
                                                                xs={12}>

                                                                <Button
                                                                    disabled={!values.budgetid}
                                                                    color="secondary"
                                                                    size="medium"
                                                                    variant="contained"
                                                                    startIcon={<FaClipboardList />}
                                                                    onBlur={handleBlur}
                                                                    onClick={() => { handleAddItem(values) }}>
                                                                    Adicionar
                                                                </Button>
                                                            </Grid>

                                                            <Grid item
                                                                md="auto"
                                                                xs={12}
                                                                fullWidth>
                                                                <IconButton
                                                                    color="secondary"
                                                                    variant="contained"
                                                                    disabled={!values.budgetid}
                                                                    children={<AiOutlineClear />}
                                                                    size="small"
                                                                    onClick={() => { clearFields(item) }}>
                                                                </IconButton>
                                                            </Grid>

                                                        </Grid>

                                                        <br></br>

                                                        <Grid container
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="center"
                                                            spacing={1}  >

                                                            <Grid item
                                                                md={12}
                                                                xs={12}>

                                                                <ResultsProducts
                                                                    resultset={{
                                                                        loaded: true,
                                                                        records: dependencies.items.length,
                                                                        pages: 1,
                                                                        page: 1,
                                                                        count: dependencies.items.length,
                                                                        rows: dependencies.items
                                                                    }}
                                                                    resultModes={budgetResultModes}
                                                                    icon={FaClipboardList}
                                                                    vision={{}}
                                                                    selectedMode={selectedMode}
                                                                    openEdition={(itemdesp) => {
                                                                        editItem(itemdesp, values);
                                                                    }}
                                                                    openDeletion={(itemdesp) => {
                                                                        removeItem(itemdesp, values);
                                                                    }}
                                                                    openTreatment={() => { }}
                                                                    openExportDialog={false}
                                                                    values={values}
                                                                />

                                                            </Grid>

                                                            <Grid item md={3} xs={12}  >

                                                                <FormControlLabel variant="outlined"
                                                                    control={<IconButton
                                                                        disabled={!values.chavePdf}
                                                                        color="secondary"
                                                                        target="_blank"
                                                                        size="medium"
                                                                        href={process.env.REACT_APP_AGM_ENDPPOINT + '/documentos/baixar/' + values.chavePdf + '/download'}>
                                                                        <ImFilePdf size={20} />
                                                                    </IconButton>}
                                                                    label={(values.chavePdf ? <Link href={process.env.REACT_APP_AGM_ENDPPOINT + '/documentos/baixar/' + values.chavePdf + '/download'}>Visualizar arquivo PDF do orçamento</Link> : 'Visualizar arquivo PDF do orçamento')}
                                                                />

                                                            </Grid>

                                                            <Grid item md={9} xs={12}  >
                                                                <FormControlLabel
                                                                    control={<ColorCheckbox
                                                                        disabled={!values.budgetnumero}
                                                                        checked={values.atualizarPdf}
                                                                        onChange={handleChange}
                                                                        name="atualizarPdf"
                                                                        id="atualizarPdf" />}
                                                                    label={`${(values.chavePdf) ? 'Atualizar PDF do Orçamento ao Salvar' : 'Gerar PDF do Orçamento ao Salvar'}`}
                                                                />

                                                            </Grid>

                                                        </Grid>

                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                        </Grid>

                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={6} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            className={classes.doned}
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink required htmlFor="conclusionStatus">Status de Realização</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.conclusionStatus && errors.conclusionStatus)}
                                                        value={values.conclusionStatus}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Status de Realização"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'conclusionStatus',
                                                            id: 'conclusionStatus',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.conclusionStatusList.map((conclusionStatus) => (
                                                            <MenuItem key={conclusionStatus.id} value={conclusionStatus.id}>{conclusionStatus.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    cancelLabel="Cancelar"
                                                    margin="none"
                                                    inputVariant="outlined"
                                                    id="dateStarted"
                                                    label="Data de Início Real"
                                                    format="DD/MM/YYYY"
                                                    name="dateStarted"
                                                    value={values.dateStarted}
                                                    onBlur={handleBlur}
                                                    onChange={value => setFieldValue("dateStarted", value)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <KeyboardDatePicker
                                                    fullWidth
                                                    cancelLabel="Cancelar"
                                                    margin="none"
                                                    minDate={(values.dateStarted) ? values.dateStarted : ""}
                                                    inputVariant="outlined"
                                                    id="datefinished"
                                                    label="Data de Finalização Real"
                                                    format="DD/MM/YYYY"
                                                    name="datefinished"
                                                    value={values.datefinished}
                                                    onBlur={handleBlur}
                                                    onChange={value => setFieldValue("datefinished", value)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <NumberFormat
                                                    fullWidth
                                                    label="Total de Horas de Execução do Serviço"
                                                    margin="none"
                                                    name="timeService"
                                                    id="timeService"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.timeService}
                                                    variant="outlined"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={
                                                        { readOnly: false, }
                                                    }
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <NumberFormat
                                                    fullWidth
                                                    required={values.conclusionStatus == 3}
                                                    label="Quilometragem do Veículo (Km)"
                                                    margin="none"
                                                    name="kmService"
                                                    id="kmService"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.kmService}
                                                    variant="outlined"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={
                                                        { readOnly: false, }
                                                    }
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}
                                            >
                                                <TextField
                                                    error={Boolean(touched.executed && errors.executed)}
                                                    required={values.conclusionStatus == 3}
                                                    fullWidth
                                                    helperText="Coloque aqui a descrição do Serviço Executado e outros detalhes (1024 caracteres)."
                                                    label="Serviço Executado"
                                                    minRows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 8 : 4}
                                                    maxRows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 8 : 4}
                                                    size={5}
                                                    length={1024}
                                                    multiline
                                                    margin="none"
                                                    name="executed"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.executed}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={
                                                        { readOnly: false, }
                                                    }
                                                />
                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>

                                                <Grid item
                                                    xs="auto">
                                                    <Button
                                                        color="secondary"
                                                        disabled={isSubmitting}
                                                        size="small"
                                                        variant="contained"
                                                        startIcon={<FaTasks />}
                                                        onClick={() => { openActionEdition({}) }}>
                                                        Adicionar Ação
                                                    </Button>
                                                </Grid>


                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>

                                                <ResultsActions
                                                    resultset={{
                                                        loaded: true,
                                                        records: dependencies.actions.length,
                                                        pages: 1,
                                                        page: 1,
                                                        count: dependencies.actions.length,
                                                        rows: dependencies.actions
                                                    }}
                                                    resultModes={actionsResultModes}
                                                    icon={FaTasks}
                                                    vision={{}}
                                                    selectedMode={selectedMode}
                                                    openEdition={openActionEdition}
                                                    openDeletion={openDeletionAction}
                                                    openTreatment={() => { }}
                                                    openExportDialog={false}
                                                    values={values}
                                                />

                                            </Grid>

                                        </Grid>

                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={7} selectedMode={selectedMode}>
                                    <Box className={classes.container} >

                                        <Grid
                                            className={classes.doned}
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>

                                                <Card>
                                                    <CardContent>

                                                        <Grid container
                                                            direction="row"
                                                            justify="flex-start"
                                                            alignItems="center"
                                                            spacing={2}  >

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>

                                                                <TextField
                                                                    fullWidth
                                                                    label="Código"
                                                                    margin="none"
                                                                    name="expenseCodigo"
                                                                    id="expenseCodigo"
                                                                    onBlur={e => {
                                                                        handleBlur(e);
                                                                    }}
                                                                    onChange={handleChange}
                                                                    value={values.expenseCodigo}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <TextField
                                                                    fullWidth
                                                                    label="Nome do Item"
                                                                    margin="none"
                                                                    name="expenseNome"
                                                                    id="expenseNome"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.expenseNome}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </Grid>

                                                            <Grid item
                                                                md={1}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="expenseTipo">Tipo de Despesa *</InputLabel>
                                                                    <Select notched
                                                                        required={false}
                                                                        fullWidth={true}
                                                                        label="Tipo de Despesa *"
                                                                        variant="outlined"
                                                                        id="expenseTipo"
                                                                        name="expenseTipo"
                                                                        value={values.expenseTipo}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        inputProps={{
                                                                            name: 'expenseTipo',
                                                                            id: 'expenseTipo',
                                                                        }}
                                                                    >
                                                                        {dependencies.expensesType.map((type) => (
                                                                            <MenuItem key={type.id} value={type.id}>{type.nome}</MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>


                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Qtd"
                                                                    margin="none"
                                                                    name="expenseQtd"
                                                                    id="expenseQtd"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.expenseQtd}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={1}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    label="Valor Despesa"
                                                                    margin="none"
                                                                    name="expenseValor"
                                                                    id="expenseValor"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.expenseValor}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md="auto"
                                                                xs={12}>
                                                                <TextField
                                                                    fullWidth
                                                                    maxLength="15"
                                                                    label="Número da Nota"
                                                                    margin="none"
                                                                    name="expenseNota"
                                                                    id="expenseNota"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.expenseNota}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={2}
                                                                xs={12}>

                                                                <FormControl variant="outlined" fullWidth>
                                                                    <InputLabel shrink htmlFor="expenseNotaFornecedor">Fornecedor</InputLabel>
                                                                    <Select notched
                                                                        autosize={true}
                                                                        error={Boolean(touched.expenseNotaFornecedor && errors.expenseNotaFornecedor)}
                                                                        value={values.expenseNotaFornecedor}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label="Fornecedor"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            name: 'expenseNotaFornecedor',
                                                                            id: 'expenseNotaFornecedor',
                                                                        }}
                                                                    >
                                                                        <MenuItem value={null}>
                                                                            <em>Selecione uma das opções abaixo</em>
                                                                        </MenuItem>

                                                                        {dependencies.expensesProvider.map((fornecedor) => (
                                                                            <MenuItem key={fornecedor.id} value={fornecedor.id}>{fornecedor.nome}</MenuItem>
                                                                        ))}


                                                                    </Select>
                                                                </FormControl>

                                                            </Grid>

                                                            <Grid item
                                                                md="auto"
                                                                xs={12}>

                                                                <Button
                                                                    color="secondary"
                                                                    size="medium"
                                                                    variant="contained"
                                                                    startIcon={<PaymentIcon />}
                                                                    onBlur={handleBlur}
                                                                    onClick={() => { handleAddExpense(values) }}>
                                                                    Adicionar Despesa
                                                                </Button>
                                                            </Grid>

                                                        </Grid>

                                                        <br></br>

                                                        <Grid container
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="center"
                                                            spacing={1}  >

                                                            <Grid item
                                                                md={12}
                                                                xs={12}>

                                                                <ResultsExpenses
                                                                    resultset={{
                                                                        loaded: true,
                                                                        records: dependencies.expenses.length,
                                                                        pages: 1,
                                                                        page: 1,
                                                                        count: dependencies.expenses.length,
                                                                        rows: dependencies.expenses
                                                                    }}
                                                                    resultModes={expensesResultModes}
                                                                    icon={PaymentIcon}
                                                                    vision={{}}
                                                                    selectedMode={selectedMode}
                                                                    openEdition={() => { }}
                                                                    openDeletion={(itemdesp) => {
                                                                        removeExpense(itemdesp, values);
                                                                    }}
                                                                    openTreatment={() => { }}
                                                                    openExportDialog={false}
                                                                    values={values}
                                                                />

                                                            </Grid>

                                                            <Grid item md={9} xs={12}  >
                                                                <FormControlLabel
                                                                    control={<ColorCheckbox
                                                                        disabled={dependencies.expenses.length == 0}
                                                                        checked={values.baixarEstoque}
                                                                        onChange={handleChange}
                                                                        name="baixarEstoque"
                                                                        id="baixarEstoque" />}
                                                                    label="Efetuar Baixa no estoque dos items de despesas que ainda não foram baixados, ao salvar"
                                                                />

                                                            </Grid>

                                                        </Grid>

                                                    </CardContent>
                                                </Card>
                                            </Grid>

                                        </Grid>

                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={8} selectedMode={selectedMode}>

                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid item
                                                md="auto"
                                                xs={12}>
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting || dependencies.documents.length == 0}
                                                    size="small"
                                                    startIcon={<MdFileDownload />}
                                                    variant="contained"
                                                    href={(values && values.ocorrencia) ? process.env.REACT_APP_AGM_ENDPPOINT + "/documentos/zip/" + values.ocorrencia.id + ',' + values.ocorrencia.numero : ""}>
                                                    Baixar Documentos
                                                </Button>

                                            </Grid>
                                            <Grid item
                                                md="auto"
                                                xs={12}>
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    startIcon={<MdOutlineFileUpload />}
                                                    variant="contained"
                                                    onClick={() => { openUpload(values) }}>
                                                    Enviar Documentos
                                                </Button>
                                            </Grid>

                                            <Grid item
                                                xs="auto">
                                                <Typography variant='h4' color='secondary' ><b>[ {(dependencies.documents.length) == 1 ? ('1 Documento') : (dependencies.documents.length + ' Documentos')} ]</b></Typography>
                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>
                                                <Divider className={classes.groupdivider}></Divider>
                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>

                                                <Documents
                                                    documents={dependencies.documents}
                                                    openDocumentEdition={openDocumentEdition}
                                                    openDeletionDocument={openDeletionDocument}
                                                    openUpload={openUpload}
                                                    values={values}
                                                />
                                            </Grid>

                                        </Grid>

                                    </Box>
                                </TabPanel>

                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                startIcon={<MdSave />}
                                                type="submit"
                                                variant="contained"
                                                onClick={() => { setSave(false) }}>
                                                Salvar
                                            </Button>
                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Fechar
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Box>

                            </form>

                        )}

                    </Formik>
                </DialogContent>

            </Dialog >

        </Fragment >
    );
};

export default Occurrence;
